import isEmpty from 'lodash/isEmpty'
import { placeholderImage } from '../../modules/api/urls'
import Gallery from '../Gallery'
import styles from './CategoryImage.scss'

const CategoryImage = props => {
    const images = !isEmpty(props.images) ? props.images : [placeholderImage]

    const imgArray = images.map((item, index) => ({
        src: item,
        thumbnail: item,
        useForDemo: index === 0
    }))

    return isEmpty(props.images) ? (
        <img class={styles.placeHolderImg} src={placeholderImage} alt="No image" />
    ) : (
        <Gallery images={imgArray} showThumbnails />
    )
}

export default CategoryImage



// WEBPACK FOOTER //
// ./components/CategoryItem/CategoryImage.js